<template>
    <c-dialog ref="dialog" title="完成维修" width="500"  mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="submitHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="单据编号">
                <c-input name="document_number" disabled></c-input>
            </c-form-item>

            <c-form-item label="资产信息">
                <c-input name="asset_info" disabled></c-input>
            </c-form-item>

            <c-form-item label="维修时间" required>
                <c-datetime name="finish_time" type="datetime" format="yyyy-MM-dd hh:mm" :value="defaultFinishTime"></c-datetime>
            </c-form-item>

            <c-form-item label="维修说明">
                <c-input name="finish_remark" type="textarea" maxlength="500" :rows="4" placeholder="请输入维修说明"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetRepairFinishDialog',

    data() {
        return {
            defaultFinishTime: ''
        }
    },

    methods: {
        open(data) {
            this.$refs.form.clear();

            const now = new Date();
            this.defaultFinishTime = this.formatDateTime(now);

            this.$refs.form.set({
                id: data.id,
                document_number: data.document_number,
                asset_info: `${data.asset_code||''} - ${data.asset_name}`,
                finish_time: this.defaultFinishTime
            });

            this.$refs.dialog.open();
        },

        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },

        submitHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/asset_repair_record/complete',
                rule: {
                    finish_time: '请选择完成时间'
                },
                success: () => {
                    next();
                    this.$message({
                        message: '完成维修成功',
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>
